var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopdeals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1475_23300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F59E0B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1475_23300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4653 14.5451C22.4653 12.0392 20.4264 10 17.9206 10C15.4147 10 13.3762 12.0392 13.3762 14.5451C13.3762 17.0502 15.4147 19.0887 17.9206 19.0887C20.4264 19.0888 22.4653 17.0503 22.4653 14.5451ZM15.6337 14.5451C15.6337 13.2833 16.6596 12.2575 17.9206 12.2575C19.1816 12.2575 20.2078 13.2833 20.2078 14.5451C20.2078 15.8053 19.1816 16.8312 17.9206 16.8312C16.6596 16.8312 15.6337 15.8054 15.6337 14.5451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0793 20.9111C25.5734 20.9111 23.5349 22.9497 23.5349 25.4548C23.5349 27.9607 25.5734 29.9999 28.0793 29.9999C30.5852 29.9999 32.6237 27.9607 32.6237 25.4548C32.6237 22.9496 30.5852 20.9111 28.0793 20.9111ZM28.0793 27.7424C26.8183 27.7424 25.7924 26.7165 25.7924 25.4548C25.7924 24.1945 26.8183 23.1686 28.0793 23.1686C29.3403 23.1686 30.3662 24.1945 30.3662 25.4548C30.3662 26.7165 29.3403 27.7424 28.0793 27.7424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2192 10.5826C27.6295 10.2556 26.884 10.4665 26.5551 11.0567L17.2781 27.7145C16.9493 28.3046 17.1614 29.0497 17.7517 29.3789C17.9402 29.4833 18.1446 29.5333 18.3459 29.5333C18.7754 29.5333 19.1921 29.3069 19.4159 28.905L28.6929 12.2471C29.0217 11.6569 28.8097 10.9118 28.2192 10.5826Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1475_23300",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1475_23300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1475_23300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1475_23300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopdeals);
export default __webpack_public_path__ + "static/media/topdeals.944cf2c645471d3c602cf82a8f0636f5.svg";
export { ForwardRef as ReactComponent };